module.exports = __webpack_public_path__ + "f6e5445aa04c8129edd16e8544b1fa1e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/TR.svg
// module id = 1kus
// module chunks = 0